export default __webpack_public_path__ + "static/media/design-mention.71b0b16f.svg";